import { read, write } from './storage';
import API_BASE from './config';

const PICKS_KEY = 'f1_picks';

export function adminSavePicks(userId, picks, raceId, dnf, bonusAnswers) {
    const body = {
        pick_4: picks[3] || null,
        pick_5: picks[4] || null,
        pick_6: picks[5] || null,
        pick_7: picks[6] || null,
        pick_8: picks[7] || null,
        pick_9: picks[8] || null,
        pick_10: picks[9] || null,
        dnf_driver: dnf,
        bonus_answers: bonusAnswers || null,
    };
    return fetch(`${API_BASE}/picks/admin?raceId=${encodeURIComponent(raceId)}&userId=${encodeURIComponent(userId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
    }).then((res) => {
        if (!res.ok) throw new Error('Failed to save picks (admin)');
        return res.json();
    });
}

export function getPicks(raceId, userId) {
    // try backend endpoint first. If username provided, use user-scoped endpoint.
    if (!raceId) return Promise.resolve(read(PICKS_KEY) || []);
    if (!userId) {
        const all = read(PICKS_KEY) || [];
        return Promise.resolve(all.filter((p) => p.raceId === raceId));
    }

    const url = `${API_BASE}/picks?raceId=${encodeURIComponent(raceId)}&userId=${encodeURIComponent(userId)}`;

    return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then((res) => {
            if (!res.ok) throw new Error('Network response not ok');
            const ct = res.headers.get('content-type') || '';
            if (!ct.includes('application/json')) throw new Error('Non-JSON response');
            return res.json();
        })
        .then(async (data) => {
            // backend returns a single row with pick_4..pick_10 and dnf_driver
            if (!data || Object.keys(data).length === 0) return [];
            const picks = [null, null, null,
                data.pick_4 == null ? null : data.pick_4,
                data.pick_5 == null ? null : data.pick_5,
                data.pick_6 == null ? null : data.pick_6,
                data.pick_7 == null ? null : data.pick_7,
                data.pick_8 == null ? null : data.pick_8,
                data.pick_9 == null ? null : data.pick_9,
                data.pick_10 == null ? null : data.pick_10
            ];

            const dnfVal = data.dnf_driver == null ? null : data.dnf_driver;
            const bonusAnswers = data.bonus_answers || null;

            return [{ username: userId, raceId, picks, dnf: dnfVal, bonus_answers: bonusAnswers }];
        })
        .catch((err) => {
            console.error('picksApi.getPicks error', err);
            const all = read(PICKS_KEY) || [];
            if (userId) return all.filter((p) => p.raceId === raceId && p.userId === userId);
            return all.filter((p) => p.raceId === raceId);
        });
}


export async function savePicks(userId, picks, raceId, dnf = 'No DNF', bonusAnswers = null) {
    const entry = { raceId, userId, picks, dnf, bonus_answers: bonusAnswers };
    // attempt to POST to backend; if not available, fallback to local storage
    if (!userId) {
        // no username -> local fallback
        const all = read(PICKS_KEY) || [];
        const idx = all.findIndex((p) => p.raceId === raceId && p.userId === userId);
        if (idx >= 0) all[idx] = entry; else all.push(entry);
        write(PICKS_KEY, all);
        return Promise.resolve(entry);
    }

    const postUrl = `${API_BASE}/picks?raceId=${encodeURIComponent(raceId)}&userId=${encodeURIComponent(userId)}`;
    const body = {
        pick_4: picks[3] || null,
        pick_5: picks[4] || null,
        pick_6: picks[5] || null,
        pick_7: picks[6] || null,
        pick_8: picks[7] || null,
        pick_9: picks[8] || null,
        pick_10: picks[9] || null,
        dnf_driver: dnf === 'No DNF' ? null : dnf,
        bonus_answers: bonusAnswers || null,
    };

    // Attempt to map driver names to IDs before posting. If mapping incomplete, fall back to local storage.
    try {
        const drvRes = await fetch(`${API_BASE}/drivers`, { headers: { 'Accept': 'application/json' } });
        if (!drvRes.ok) throw new Error('Drivers fetch failed');
        const drvCt = drvRes.headers.get('content-type') || '';
        if (!drvCt.includes('application/json')) throw new Error('Drivers non-JSON');
        const drivers = await drvRes.json();

        const findId = (nameOrId) => {
            if (!nameOrId) return null;
            if (typeof nameOrId === 'number') return nameOrId;
            const name = String(nameOrId).trim();
            // try code or id match
            const byCode = drivers.find((d) => (d.code && d.code === name));
            if (byCode) return byCode.id;
            // try full name
            const byName = drivers.find((d) => {
                const full = `${d.first_name || ''} ${d.last_name || ''}`.trim();
                return full === name || d.name === name;
            });
            if (byName) return byName.id;
            return null;
        };

        // const mapped = {
        //     pick_4: findId(body.pick_4),
        //     pick_5: findId(body.pick_5),
        //     pick_6: findId(body.pick_6),
        //     pick_7: findId(body.pick_7),
        //     pick_8: findId(body.pick_8),
        //     pick_9: findId(body.pick_9),
        //     pick_10: findId(body.pick_10),
        //     dnf_driver: body.dnf_driver ? findId(body.dnf_driver) : null,
        // };

        // const anyMissing = [mapped.pick_4, mapped.pick_5, mapped.pick_6, mapped.pick_7, mapped.pick_8, mapped.pick_9, mapped.pick_10].some((v) => !v);
        // if (anyMissing) {
        //     console.warn('picksApi.savePicks: not all picks mapped to driver IDs, falling back to localStorage');
        //     const all = read(PICKS_KEY) || [];
        //     const idx = all.findIndex((p) => p.raceId === raceId && p.username === username);
        //     if (idx >= 0) all[idx] = entry; else all.push(entry);
        //     write(PICKS_KEY, all);
        //     return Promise.resolve(entry);
        // }

        return fetch(postUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body),
        }).then((res) => {
            if (!res.ok) {
                if (res.status === 423) {
                    return res.json()
                        .then((data) => {
                            const lockedErr = new Error(data?.error || 'Picks are locked for this race');
                            lockedErr.locked = true;
                            throw lockedErr;
                        })
                        .catch((parseErr) => {
                            if (parseErr && parseErr.locked) throw parseErr;
                            const lockedErr = new Error('Picks are locked for this race');
                            lockedErr.locked = true;
                            throw lockedErr;
                        });
                }
                console.error('picksApi.savePicks server returned non-ok response', res.status);
                // fallback
                const all = read(PICKS_KEY) || [];
                const idx = all.findIndex((p) => p.raceId === raceId && p.userId === userId);
                if (idx >= 0) all[idx] = entry; else all.push(entry);
                write(PICKS_KEY, all);
                return entry;
            }
            const ct = res.headers.get('content-type') || '';
            if (!ct.includes('application/json')) return entry;
            return res.json().catch((err) => {
                console.error('picksApi.savePicks parse error', err);
                return entry;
            });
        }).catch((err) => {
            if (err && err.locked) {
                return Promise.reject(err);
            }
            console.error('picksApi.savePicks network error', err);
            const all = read(PICKS_KEY) || [];
            const idx = all.findIndex((p) => p.raceId === raceId && p.userId === userId);
            if (idx >= 0) all[idx] = entry; else all.push(entry);
            write(PICKS_KEY, all);
            return Promise.resolve(entry);
        });
    } catch (err) {
        console.error('picksApi.savePicks error', err);
        const all = read(PICKS_KEY) || [];
        const idx = all.findIndex((p) => p.raceId === raceId && p.userId === userId);
        if (idx >= 0) all[idx] = entry; else all.push(entry);
        write(PICKS_KEY, all);
        return Promise.resolve(entry);
    }
}
